import React from 'react';
import { Route } from 'react-router-dom';
import AvailabilityDetailsPageRoute from './AvailabilityDetailsPageRoute';

const basePath = '/v2/availability/:metadataId';

export default (
  <Route path={basePath}>
    <AvailabilityDetailsPageRoute />
  </Route>
);
